import { useTranslation } from 'react-i18next'
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'
import { ErrorState } from '../ui/index.js'
import { log } from './log.js'

const logger = log('router')

/** The router level catch. CONVENTIONS §3: never a blank screen, always a retry. */
export function RouteErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error)
  logger.error('a route threw', detail)

  return (
    <ErrorState
      text={t('error.generic')}
      retryLabel={t('app.retry')}
      onRetry={() => navigate(0)}
      detail={detail}
    />
  )
}
